export default __webpack_public_path__ + "static/media/Slogo.7ef59e45.svg";